(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[538],{

/***/ 9953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Abm_Button; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(42);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Icon/icons/cornerArrow.inline.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgCornerArrowinline = props => /*#__PURE__*/react.createElement("svg", _extends({
  fill: "none",
  height: 12,
  viewBox: "0 0 12 12",
  width: 12,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "m1 11 10-10m0 0h-10m10 0v10",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

/* harmony default export */ var cornerArrow_inline = (SvgCornerArrowinline);
// EXTERNAL MODULE: ./src/components/Abm/Button.module.scss
var Button_module = __webpack_require__(8593);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./src/components/Abm/Button.jsx




var Button = function(param) {
    var _button = param.button, button = _button === void 0 ? {
        url: "#",
        label: ""
    } : _button, _isSecondary = param.isSecondary, isSecondary = _isSecondary === void 0 ? false : _isSecondary, onClick = param.onClick, className = param.className, ariaLabel = param.ariaLabel;
    return button && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        "aria-label": ariaLabel,
        className: classnames_default()((Button_module_default()).button, isSecondary ? (Button_module_default()).secondary : "", className),
        onClick: onClick,
        href: button.url,
        children: [
            button.label,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(cornerArrow_inline, {
                alt: "arrow",
                className: (Button_module_default()).arrow,
                loading: "lazy"
            })
        ]
    });
};
/* harmony default export */ var Abm_Button = (Button);


/***/ }),

/***/ 8984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ setDefaultAccentColors; }
/* harmony export */ });
var setDefaultAccentColors = function() {
    var rootStyle = document.querySelector(":root").style;
    rootStyle.setProperty("--accentColorPrimaryBackground", "#feb80a");
    rootStyle.setProperty("--accentColorPrimaryText", "#fff");
    rootStyle.setProperty("--accentColorSecondaryBackground", "#012f34");
    rootStyle.setProperty("--accentColorSecondaryText", "#fff");
};


/***/ }),

/***/ 7263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout_BaseLayout; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(8038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(3254);
// EXTERNAL MODULE: ../node_modules/axios/index.js
var axios = __webpack_require__(4206);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../@hiredigital/lib/src/helpers/utils.js
var utils = __webpack_require__(7708);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/InterceptorProvider/index.jsx







var InterceptorProvider = function(param) {
    var _requests = param.requests, requests = _requests === void 0 ? [] : _requests, onAuthorizationError = param.onAuthorizationError, onNetworkError = param.onNetworkError, onNetworkSuccess = param.onNetworkSuccess, children = param.children;
    (0,react.useEffect)(function() {
        attach(requests);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var makeSentence = function(curKey, description) {
        var name = [
            "non_field_errors",
            "nonFieldErrors"
        ].includes(curKey) ? "" : "".concat((0,utils/* toSentenceCase */.wR)(curKey), ": ");
        return "".concat(name).concat(description);
    };
    var reduce = function(error) {
        if (typeof error === "object") {
            return Object.keys(error).reduce(function(prev, curKey) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    makeSentence(curKey, error[curKey])
                ]);
            }, []).join(" ");
        }
        return error;
    };
    // simplify the error description and the index/prop of an object or array into one sentence
    var simplify = function(errors) {
        if (typeof errors !== "object") return [
            errors
        ];
        return Object.keys(errors).reduce(function(prev, curKey) {
            var error = errors[curKey];
            if (Array.isArray(error)) {
                // const name = toSentenceCase(curKey !== 'non_field_errors' ? `${curKey}` : '');
                return error.map(function(v) {
                    return makeSentence(curKey, v);
                });
            }
            return (0,_to_consumable_array/* default */.Z)(prev).concat([
                reduce(error)
            ]);
        }, []);
    };
    // transform the error into array of string errors
    var transform = function(error) {
        var ref;
        var data = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data;
        var err = "There was an error with your request. Please try again.";
        if (!data) {
            return [
                err
            ];
        }
        if (typeof data.detail == "string") {
            return [
                data.detail
            ];
        }
        if (typeof data == "string") {
            if (data.length > 100) return [
                err
            ];
            else return [
                data
            ];
        }
        // Special handling for Wise API errors
        var errors = data.errors;
        if (Array.isArray(errors) && errors.length) {
            var wiseErrors = [];
            var isCurrency = false;
            var isType = false;
            errors.forEach(function(err) {
                (err === null || err === void 0 ? void 0 : err.message) && wiseErrors.push(err.message);
                isCurrency = isCurrency || "currency" === (err === null || err === void 0 ? void 0 : err.path);
                isType = isType || "type" === (err === null || err === void 0 ? void 0 : err.path);
            });
            if (isCurrency) return [
                "Please select a currency."
            ];
            if (isType) return [
                "Please select a 'Pay to' option."
            ];
            return wiseErrors;
        }
        var values = simplify(data);
        if (values.length > 100) {
            return [
                err
            ];
        }
        return values;
    };
    var attach = function(https) {
        https.forEach(function(item) {
            item.interceptors.response.handlers = [];
            item.interceptors.response.use(function(response) {
                onNetworkSuccess === null || onNetworkSuccess === void 0 ? void 0 : onNetworkSuccess();
                return response;
            }, function(error) {
                var ref, ref1;
                if (!(error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status)) {
                    onNetworkError === null || onNetworkError === void 0 ? void 0 : onNetworkError();
                    return;
                }
                if (!axios_default().isCancel(error)) {
                    transform(error).forEach(function(v) {
                        return react_hot_toast_esm/* default.error */.ZP.error(v, {
                            id: v
                        });
                    });
                }
                if ((error === null || error === void 0 ? void 0 : (ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 401) {
                    // authorization error
                    if (onAuthorizationError) {
                        // in some cases, we need to redirect to external url
                        // for instance the login page of frontend app is located in the marketing site
                        onAuthorizationError();
                    } else {
                        // just return to the home page if no handler provided when authorization error occurs
                        window.location.href = "/";
                    }
                    return;
                }
                return Promise.reject(error);
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hot_toast_esm/* Toaster */.x7, {}),
            children
        ]
    });
};
InterceptorProvider.propTypes = {
    children: (prop_types_default()).node,
    requests: (prop_types_default()).array,
    onAuthorizationError: (prop_types_default()).func
};
/* harmony default export */ var src_InterceptorProvider = (InterceptorProvider);

// EXTERNAL MODULE: ./src/shared/apis/utils.js
var apis_utils = __webpack_require__(8137);
;// CONCATENATED MODULE: ./src/components/Layout/defaults.js
var defaultHead = {
    title: "Poly",
    meta: [
        {
            name: "image",
            content: "https://media.graphassets.com/KHdcQPVVQriSFc4v9xQN"
        },
        {
            name: "description",
            content: "Poly is a leading provider of in-housing, staffing, and digital solutions to Fortune 100 and other fast-growing companies."
        }, 
    ],
    link: []
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(5963);
;// CONCATENATED MODULE: ./src/components/Layout/utils.jsx




var convertPropsToHeadElements = function(attributes) {
    if (!attributes) return null;
    var attributeKeys = Object.keys(attributes);
    var helmetAttributes = [];
    for(var i = 0; i < attributeKeys.length; i++){
        var Elem = attributeKeys[i];
        var data = attributes[attributeKeys[i]];
        if (typeof data === "string" || (0,_instanceof/* default */.Z)(data, String)) {
            helmetAttributes.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Elem, {
                children: data
            }, attributeKeys[i]));
        } else if (Array.isArray(data)) {
            for(var j = 0; j < data.length; j++){
                var arrDataObj = data[j];
                helmetAttributes.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(Elem, (0,src_object_spread/* default */.Z)({}, arrDataObj), "".concat(attributeKeys[i], "-").concat(arrDataObj["name"] || arrDataObj["property"])));
            }
        }
    }
    return helmetAttributes;
};
var cleanPageHead = function(pageHead) {
    var newPageHead = pageHead;
    if (!newPageHead) return null;
    if (newPageHead.meta === null) {
        newPageHead.meta = [];
    }
    if (newPageHead.link === null) {
        newPageHead.link = [];
    }
    return newPageHead;
};
var getMetaContent = function(head, name) {
    if (!head || !head.meta) {
        return null;
    }
    if (Array.isArray(head.meta)) {
        var metaObj = head.meta.find(function(meta) {
            return meta.name === name || meta.property === name;
        });
        if (metaObj) {
            return metaObj.content;
        }
    } else if (head.meta.name === name || head.meta.property === name) {
        return head.meta.content;
    }
    return null;
};
var generateSchema = function(param, postSchema, schemaFaq) {
    var title = param.title, image = param.image, description = param.description, url = param.url, isPost = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var data = [
        {
            "@context": "http://schema.org",
            "@type": "WebSite",
            url: url,
            name: title,
            alternateName: "Poly"
        }, 
    ];
    if (isPost) {
        data.push({
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
                {
                    "@type": "ListItem",
                    position: 1,
                    item: {
                        "@id": url,
                        name: title,
                        image: image
                    }
                }, 
            ]
        }, {
            "@context": "http://schema.org",
            "@type": "BlogPosting",
            url: url,
            name: title,
            alternateName: "Poly",
            headline: title,
            image: {
                "@type": "ImageObject",
                url: image
            },
            description: description,
            mainEntityOfPage: {
                "@type": "WebPage",
                "@id": url
            },
            author: {
                "@type": "Person",
                name: (postSchema === null || postSchema === void 0 ? void 0 : postSchema.author) || "Poly Editorial"
            },
            publisher: {
                "@type": "Organization",
                name: (postSchema === null || postSchema === void 0 ? void 0 : postSchema.publisher) || "Poly",
                logo: {
                    "@type": "ImageObject",
                    url: "http://cdn.hiredigital.com/email/hd-logo-small.png"
                }
            },
            datePublished: postSchema === null || postSchema === void 0 ? void 0 : postSchema.datePublished,
            dateModified: postSchema === null || postSchema === void 0 ? void 0 : postSchema.dateModified
        }, (0,src_object_spread/* default */.Z)({}, schemaFaq));
    } else {
        data.push({
            "@context": "http://schema.org",
            "@type": "WebPage",
            url: url,
            name: title,
            alternateName: "Poly",
            image: image,
            description: description
        }, (0,src_object_spread/* default */.Z)({}, schemaFaq));
    }
    return JSON.stringify(data);
};
var generateSocial = function(param) {
    var title = param.title, image = param.image, description = param.description, url = param.url, isPost = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        meta: [
            {
                name: "twitter:title",
                content: title
            },
            {
                name: "twitter:description",
                content: description
            },
            image ? {
                property: "twitter:image",
                content: image
            } : {},
            {
                name: "twitter:card",
                content: "summary_large_image"
            },
            {
                name: "twitter:site",
                content: "@hiredigital1"
            },
            {
                name: "twitter:creator",
                content: "@hiredigital1"
            },
            {
                property: "og:title",
                content: title
            },
            {
                property: "og:description",
                content: description
            },
            image ? {
                property: "og:image",
                content: image
            } : {},
            {
                property: "og:url",
                content: url
            },
            {
                property: "og:type",
                content: isPost ? "article" : "website"
            }, 
        ]
    };
};
var generateProd = function() {
    return {
        meta: [
            {
                property: "fb:app_id",
                content: "XXXXXXXXXXXXXX"
            }
        ]
    };
};
var generateDev = function() {
    return {
        meta: [
            {
                name: "robots",
                content: "noindex"
            }
        ]
    };
};
var generateFaqSchema = function(data) {
    if (!data) return;
    var mainEntity = [];
    var schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: []
    };
    data === null || data === void 0 ? void 0 : data.map(function(param) {
        var answer = param.answer, question = param.question;
        mainEntity.push({
            "@type": "Question",
            name: removeExtraSpace(removeLineBreaks(question)),
            acceptedAnswer: {
                "@type": "Answer",
                text: removeExtraSpace(removeLineBreaks((answer === null || answer === void 0 ? void 0 : answer.html) || (answer === null || answer === void 0 ? void 0 : answer.text) || answer))
            }
        });
    });
    return _object_spread_props(_object_spread({}, schema), {
        mainEntity: mainEntity
    });
};
var removeLineBreaks = function(t) {
    return t === null || t === void 0 ? void 0 : t.replace(/(\r\n|\n|\r|\\)/gm, "");
};
var removeExtraSpace = function(t) {
    return t === null || t === void 0 ? void 0 : t.replace(/\s\s+/g, " ");
};

;// CONCATENATED MODULE: ./src/components/Layout/BaseLayout.jsx












var BaseLayout = function(param) {
    var className = param.className, children = param.children, pageHead = param.pageHead, _removeMetaImage = param.removeMetaImage, removeMetaImage = _removeMetaImage === void 0 ? false : _removeMetaImage, _removeMetaSocial = param.removeMetaSocial, removeMetaSocial = _removeMetaSocial === void 0 ? false : _removeMetaSocial, _removeMetaJsonLd = param.removeMetaJsonLd, removeMetaJsonLd = _removeMetaJsonLd === void 0 ? false : _removeMetaJsonLd, initialCanonical = param.canonicalUrl;
    var router = (0,next_router.useRouter)();
    var currentPath = router.asPath.split("?")[0];
    var pageUrl = "https://frshdigital.vercel.app" + currentPath;
    var canonicalUrl = initialCanonical || "https://frshdigital.vercel.app" + currentPath;
    // const data = useLayoutQuery();
    // Note that the only one cheat we have is to allow a single image meta but it does not exist
    var commonMeta = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        title: pageHead && pageHead.title || defaultHead.title
    }, !removeMetaImage && {
        image: getMetaContent(pageHead, "image") || getMetaContent(defaultHead, "image")
    }), {
        description: getMetaContent(pageHead, "description") || getMetaContent(defaultHead, "description"),
        url: pageUrl
    });
    var socialHead = generateSocial(commonMeta, false);
    var envHead =  false ? 0 : generateDev();
    var schemaData = generateSchema(commonMeta, false);
    var helmetDefaultHead = (0,src_object_spread/* default */.Z)({}, defaultHead, removeMetaImage ? {
        meta: defaultHead.meta.filter(function(meta) {
            return meta.name !== "image";
        })
    } : {
        meta: (0,_to_consumable_array/* default */.Z)(defaultHead.meta)
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(src_InterceptorProvider, {
        requests: [
            apis_utils/* request */.WY,
            apis_utils/* authRequest */.HR,
            apis_utils/* baseRequest */.FZ
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    convertPropsToHeadElements(helmetDefaultHead),
                    convertPropsToHeadElements(pageHead),
                    !removeMetaSocial && convertPropsToHeadElements(socialHead),
                    convertPropsToHeadElements(envHead),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonicalUrl
                    }),
                    !removeMetaJsonLd && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: schemaData
                        }
                    })
                ]
            }),
            className ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: children
            }) : children
        ]
    });
};
BaseLayout.propTypes = {
    children: (prop_types_default()).node,
    pageHead: (prop_types_default()).object,
    removeMetaImage: (prop_types_default()).bool,
    removeMetaSocial: (prop_types_default()).bool,
    removeMetaJsonLd: (prop_types_default()).bool
};
BaseLayout.defaultProps = {
    removeMetaImage: false,
    removeMetaSocial: false,
    removeMetaJsonLd: false
};
/* harmony default export */ var Layout_BaseLayout = (BaseLayout);


/***/ }),

/***/ 305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);








// Custom Link component that offers backwards compatibility with GatsbyJS Link component
var CustomLink = function(_param) {
    var to = _param.to, href = _param.href, as = _param.as, _shallow = _param.shallow, shallow = _shallow === void 0 ? false : _shallow, children = _param.children, className = _param.className, activeClassName = _param.activeClassName, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "to",
        "href",
        "as",
        "shallow",
        "children",
        "className",
        "activeClassName"
    ]);
    var h = href || to;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: h,
        as: as,
        shallow: shallow,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, router.asPath === h && activeClassName)
        }, props), {
            children: children
        }))
    });
};
CustomLink.propTypes = {
    to: prop_types__WEBPACK_IMPORTED_MODULE_7___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_7___default().object)
    ]),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    activeClassName: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomLink);


/***/ }),

/***/ 7839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContainerType */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5811);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Section_module_scss__WEBPACK_IMPORTED_MODULE_2__);







var ContainerType = {
    LIGHTBLUE: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerLightblue),
    DARKBLUE: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerDarkblue),
    ENTERPRISE_SPLIT: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerEnterpriseSplit),
    ENTERPRISE_FULL: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerEnterpriseFull),
    PROFESSIONAL_SPLIT: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerProfessionalSplit),
    WHITE: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().containerPlainWhite)
};
var SectionContainer = function(_param) {
    var children = _param.children, className = _param.className, style = _param.style, anchor = _param.anchor, type = _param.type, split = _param.split, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "style",
        "anchor",
        "type",
        "split"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), split && (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().splitContainer), type, className),
        style: style
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_2___default().anchor),
                id: anchor
            }),
            children
        ]
    }));
};
SectionContainer.Type = ContainerType;
SectionContainer.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().object),
    anchor: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    split: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().bool)
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionContainer);


/***/ }),

/***/ 863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5811);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(966);





var Section = function(param) {
    var children = param.children, className = param.className, style = param.style, title = param.title, subtitle = param.subtitle, _textColor = param.textColor, textColor = _textColor === void 0 ? undefined : _textColor, _textType = param.textType, textType = _textType === void 0 ? undefined : _textType, titleClass = param.titleClass, subTitleClass = param.subTitleClass;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section), className),
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                element: "h2",
                size: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Size.SUBHEADLINE_LARGE */ .Z.Size.SUBHEADLINE_LARGE,
                color: textColor,
                type: textType,
                className: titleClass,
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                element: "p",
                size: _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Size.BODY */ .Z.Size.BODY,
                color: textColor,
                type: textType,
                className: subTitleClass,
                children: subtitle
            }),
            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().addMargin),
                children: children
            }) : children
        ]
    });
};
Section.Color = _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Color */ .Z.Color;
Section.Type = _hiredigital_ui_Text_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Type */ .Z.Type;
Section.Styles = (_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default());
Section.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    subtitle: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    color: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Section);


/***/ }),

/***/ 8137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FZ": function() { return /* binding */ baseRequest; },
/* harmony export */   "HR": function() { return /* binding */ authRequest; },
/* harmony export */   "WY": function() { return /* binding */ request; },
/* harmony export */   "kO": function() { return /* binding */ appRequest; }
/* harmony export */ });
/* unused harmony export reqNoIntercept */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4206);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios_case_converter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8815);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6248);
/* harmony import */ var regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2994);


// import fetchAdapter from '@vespaiach/axios-fetch-adapter';


var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z();
var token = cookies.get("token");
var appRequest = (0,axios_case_converter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "/api/",
    // adapter: fetchAdapter,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
}));
var request = (0,axios_case_converter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat("https://dev-api.contentco.xyz/api/v1", "/"),
    // adapter: fetchAdapter,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
}));
var authRequest = (0,axios_case_converter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat("https://dev-api.contentco.xyz/api/v1", "/"),
    // adapter: fetchAdapter,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Token ".concat(token)
    }
}));
var baseRequest = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    // adapter: fetchAdapter,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
});
var reqNoIntercept = (0,axios_case_converter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat("https://dev-api.contentco.xyz/api/v1", "/"),
    // adapter: fetchAdapter,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
}));


/***/ }),

/***/ 9020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ OrganizationType; }
/* harmony export */ });
/* unused harmony exports Enum, BriefRegistrationStatus, CallStatus, ProspectStatus, EngagementStatus, Role, ServiceRateType, PortfolioType, PopupType, Site, PreferredPlatform, ContractTypes, Currency */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4364);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7599);


var Enum = function Enum(enums) {
    "use strict";
    var _this = this;
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, Enum);
    // Copy over enum value for other usage, i.e. Enum.UserGender.MALE
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "getId", function(enumValue) {
        var ret = null;
        if (enumValue) {
            return enumValue.id;
        }
        return ret;
    });
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "getEnum", function(id) {
        return _this.values.find(function(e) {
            return e.id === id;
        });
    });
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "getEnumByKey", function(value, valueKey) {
        return _this.values.find(function(e) {
            return e[valueKey || "id"] === value;
        });
    });
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "getLabel", function(id) {
        var en = _this.values.find(function(e) {
            return e.id === id;
        });
        if (en) {
            return en.label;
        }
        return null;
    });
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "getEnumFromValue", function(value, valueName) {
        return _this.values.find(function(e) {
            return e[valueName] === value;
        });
    });
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "getIds", function(enumValues) {
        var ret = [];
        if (enumValues) {
            enumValues.forEach(function(val, i) {
                var enumId = _this.getId(val);
                if (enumId) {
                    ret.push(enumId);
                }
            });
        }
        return ret;
    });
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, "getEnums", function(ids) {
        var ret = [];
        if (ids) {
            ids.forEach(function(enumId, i) {
                var enumVal = _this.getEnum(enumId);
                if (enumVal) {
                    ret.push(enumVal);
                }
            });
        }
        return ret;
    });
    this.enums = enums;
    this.values = Object.values(enums);
    for(var prop in enums){
        if (enums.hasOwnProperty(prop)) {
            this[prop] = enums[prop];
        }
    }
};
var BriefRegistrationStatus = new Enum({
    DRAFT: {
        id: 1,
        label: "Draft"
    },
    SUBMITTED: {
        id: 2,
        label: "Submitted"
    }
});
var CallStatus = new Enum({
    SCHEDULED: {
        id: 1,
        label: "Scheduled"
    },
    CANCELLED: {
        id: 2,
        label: "Cancelled"
    },
    RESCHEDULED: {
        id: 3,
        label: "Rescheduled"
    },
    DRAFT: {
        id: 4,
        label: "Draft"
    }
});
var ProspectStatus = new Enum({
    DRAFT: {
        id: 1,
        label: "Draft"
    },
    CONVERTED: {
        id: 2,
        label: "Converted"
    },
    SUBMITTED: {
        id: 3,
        label: "Submitted"
    }
});
var EngagementStatus = new Enum({
    MATCH: {
        id: 2,
        label: "Match"
    },
    TRIAL: {
        id: 3,
        label: "Trial"
    },
    ACTIVE: {
        id: 4,
        label: "Active"
    },
    COMPLETED: {
        id: 5,
        label: "Completed"
    },
    CANCELLED: {
        id: 6,
        label: "Cancelled"
    }
});
var Role = new Enum({
    CLIENT: {
        id: 1,
        label: "Client"
    },
    TALENT: {
        id: 2,
        label: "Talent"
    }
});
var OrganizationType = new Enum({
    ENTERPRISE: {
        id: 1,
        label: "Enterprise"
    },
    PROFESSIONAL: {
        id: 2,
        label: "Professional"
    }
});
var ServiceRateType = new Enum({
    HOUR: {
        id: 1,
        label: "per hour"
    },
    DAY: {
        id: 2,
        label: "per day"
    },
    WEEK: {
        id: 3,
        label: "per week"
    },
    MONTH: {
        id: 4,
        label: "per month"
    },
    QUARTER: {
        id: 5,
        label: "per quarter"
    },
    YEAR: {
        id: 6,
        label: "per year"
    },
    PROJECT: {
        id: 7,
        label: "per project"
    }
});
var PortfolioType = {
    USER: 0,
    ORGANIZATION: 1,
    TEAM: 2,
    RESUME: 3,
    PORTFOLIO: 4,
    PUBLIC_RESUME: 5,
    PUBLIC_PORTFOLIO: 6,
    TALENT: 7,
    TEAM_SLUG: 8
};
var PopupType = {
    FULL_PAGE_MODAL: "full",
    BOTTOM_PAGE_MODAL: "bottom"
};
var Site = new Enum({
    CONTENTCO: {
        id: 1,
        label: "Content.co"
    },
    HIREDIGITAL: {
        id: 2,
        label: "Hire Digital"
    }
});
var PreferredPlatform = new Enum({
    PHONE: {
        id: 1,
        label: "Phone"
    },
    ZOOM: {
        id: 2,
        label: "Zoom"
    },
    SKYPE: {
        id: 3,
        label: "Skype"
    },
    WEB_CALL: {
        id: 4,
        label: "Web call"
    }
});
var ContractTypes = new Enum({
    FULL_TIME: {
        id: 1,
        label: "Full Time"
    },
    PART_TIME: {
        id: 2,
        label: "Part Time"
    }
});
var Currency = new Enum({
    sgd: {
        id: "SGD",
        code: "SGD",
        label: "Singapore Dollar",
        icon: "S$",
        flag: "sg"
    },
    eur_sgd: {
        id: "EUR",
        code: "EUR",
        label: "Euro",
        icon: "€",
        flag: "eu"
    },
    gbp_sgd: {
        id: "GBP",
        code: "GBP",
        label: "British Pound",
        icon: "\xa3",
        flag: "gb"
    },
    usd_sgd: {
        id: "USD",
        code: "USD",
        label: "US Dollar",
        icon: "$",
        flag: "us"
    },
    aud_sgd: {
        id: "AUD",
        code: "AUD",
        label: "Australian Dollar",
        icon: "AU$",
        flag: "au"
    },
    cad_sgd: {
        id: "CAD",
        code: "CAD",
        label: "Canadian Dollar",
        icon: "C$",
        flag: "ca"
    },
    cny_sgd_100: {
        id: "CNY",
        code: "CNY",
        label: "Chinese Renminbi",
        icon: "\xa5",
        flag: "cn"
    },
    hkd_sgd_100: {
        id: "HKD",
        code: "HKD",
        label: "Hong Kong Dollar",
        icon: "HK$",
        flag: "hk"
    },
    inr_sgd_100: {
        id: "INR",
        code: "INR",
        label: "Indian Rupee",
        icon: "₹"
    },
    idr_sgd_100: {
        id: "IDR",
        code: "IDR",
        label: "Indonesian Rupiah",
        icon: "Rp",
        flag: "in"
    },
    jpy_sgd_100: {
        id: "JPY",
        code: "JPY",
        label: "Japanese Yen",
        icon: "\xa5",
        flag: "jp"
    },
    krw_sgd_100: {
        id: "KRW",
        code: "KRW",
        label: "Korean Won",
        icon: "₩",
        flag: "kr"
    },
    myr_sgd_100: {
        id: "MYR",
        code: "MYR",
        label: "Malaysian Ringgit",
        icon: "RM",
        flag: "my"
    },
    twd_sgd_100: {
        id: "TWD",
        code: "TWD",
        label: "New Taiwan Dollar",
        icon: "NT$",
        flag: "tw"
    },
    nzd_sgd: {
        id: "NZD",
        code: "NZD",
        label: "New Zealand Dollar",
        icon: "NZ$",
        flag: "nz"
    },
    php_sgd_100: {
        id: "PHP",
        code: "PHP",
        label: "Philippine Peso",
        icon: "₱",
        flag: "ph"
    },
    qar_sgd_100: {
        id: "QAR",
        code: "QAR",
        label: "Qatar Riyal",
        icon: "﷼",
        flag: "qa"
    },
    sar_sgd_100: {
        id: "SAR",
        code: "SAR",
        label: "Saudi Arabia Riyal",
        icon: "﷼",
        flag: "sa"
    },
    chf_sgd: {
        id: "CHF",
        code: "CHF",
        label: "Swiss Franc",
        icon: "CHF",
        flag: "ch"
    },
    thb_sgd_100: {
        id: "THB",
        code: "THB",
        label: "Thai Baht",
        icon: "฿",
        flag: "th"
    },
    aed_sgd_100: {
        id: "AED",
        code: "AED",
        label: "UAE Dirham",
        icon: "د.إ;",
        flag: "ae"
    },
    vnd_sgd_100: {
        id: "VND",
        code: "VND",
        label: "Vietnamese Dong",
        icon: "₫",
        flag: "vn"
    }
});


/***/ }),

/***/ 7708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a$": function() { return /* binding */ validatePhone; },
/* harmony export */   "wR": function() { return /* binding */ toSentenceCase; }
/* harmony export */ });
/* unused harmony exports acceptedFiles, portfolioAcceptedFiles, copyTextToClipboard, copyRichTextToClipboard, getName, ensureHttpPrefix, toTitleCase, formatNumber, calculateConversion, getCurrencyIcon, formatCurrency, convertToCurrency, socialPrefixes, addHttpPrefix, setPageTitle, openUrl, formatBytes, convertNumberToText, convertToSeconds, convertToHours, generateAddress, extractTextOnly, getWordCount, getWordCountFromHtml, estimateReadTime, setValue, isOfTypeUuId, dateSort, simplifyErrors, checkImageUrl, getPortfolioThumbnail, isPortfolioThumbnailPageScreenshot, snakeToCamel, formatWithComma, removeBaseUrl */
/* harmony import */ var _marketingEnum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9020);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4206);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);


var acceptedFiles = (/* unused pure expression or super */ null && ([
    "image/*",
    "application/zip",
    "application/pdf",
    "video/*",
    "application/vnd.ms-excel",
    "application/vnd.oasis.opendocument.text",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/docx",
    "application/doc",
    "text/plain",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
]));
var portfolioAcceptedFiles = (/* unused pure expression or super */ null && ([
    "image/*",
    "application/pdf",
    "video/*",
    "application/msword",
    "application/vnd.oasis.opendocument.text",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/docx",
    "application/doc", 
]));
var copyTextToClipboard = function(text) {
    var el = document.createElement("textarea");
    document.body.appendChild(el);
    el.value = text;
    el.select();
    document.execCommand("copy");
    el.remove();
};
var copyRichTextToClipboard = function(elem) {
    if (!elem) return false;
    var sel = window.getSelection();
    var range = document.createRange();
    sel.removeAllRanges();
    range.selectNode(elem);
    sel.addRange(range);
    var ok = document.execCommand("copy");
    sel.removeAllRanges();
    return ok;
};
var getName = function(url) {
    if (url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }
    return;
};
var ensureHttpPrefix = function(value) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "http://";
    var httpPrefix = "http://";
    var httpsPrefix = "https://";
    var re = /^(https?):\/\//i;
    if (value && !re.test(value) && prefix.indexOf(value) !== 0 && httpPrefix.indexOf(value) !== 0 && httpsPrefix.indexOf(value) !== 0) {
        return prefix + value;
    }
    return value;
};
var toSentenceCase = function(_string) {
    // from Snake to Sentence
    return _string.charAt(0).toUpperCase() + _string.slice(1).replace(/([:\-_]+(.))/g, function(_, separator, letter, offset) {
        return offset ? " " + letter.toUpperCase() : letter;
    }).replace(/([A-Z])/g, " $1");
};
var toTitleCase = function(phrase) {
    var exceptions = [
        "iOS",
        "eCommerce"
    ];
    try {
        return phrase.split(" ").map(function(word) {
            return exceptions.indexOf(word) == -1 ? word.charAt(0).toUpperCase() + word.slice(1) : word;
        }).join(" ");
    } catch (e) {
        return null;
    }
};
var validatePhone = function(phone) {
    /*
  Simple phone validation 
  */ if (/^[+\d]?(?:[+\d-.,#,*"\s()]*)$/.test(phone)) {
        return true;
    }
    return false;
};
var formatNumber = function(v) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    return parseFloat(v).toFixed(decimalPlaces).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
var calculateConversion = function(amount, rate) {
    Math.log10 = Math.log10 || function(x) {
        return Math.log(x) * Math.LOG10E;
    };
    var decimalPlaces = 0;
    var baseAmount = 1 * rate;
    var roundingDigits = parseInt(Math.log10(baseAmount));
    if (Math.abs(baseAmount) < 1) {
        roundingDigits -= 1;
    }
    var roundingDigitsAmount = Math.pow(10, roundingDigits);
    var roundingAmount = Math.round(baseAmount / roundingDigitsAmount) * roundingDigitsAmount;
    if (rate < 1.5 && rate > 0.5 && amount * rate % 1 !== 0) {
        decimalPlaces = 2;
        roundingAmount = 0.01;
    }
    return formatNumber(Math.abs(Math.round(amount * rate / roundingAmount) * roundingAmount), decimalPlaces);
};
var getCurrencyIcon = function(code) {
    var ref;
    return ((ref = Currency.getEnumByKey(code, "code")) === null || ref === void 0 ? void 0 : ref.icon) || "";
};
var formatCurrency = function(v) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "$";
    return "".concat(symbol).concat(formatNumber(v, decimalPlaces));
};
var convertToCurrency = function() {
    var amount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, currency = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, showCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var code = (currency === null || currency === void 0 ? void 0 : currency.code) || (currency === null || currency === void 0 ? void 0 : currency.currencyCode);
    var rate = (currency === null || currency === void 0 ? void 0 : currency.rate) || (currency === null || currency === void 0 ? void 0 : currency.currencyRate);
    if (Object.keys(currency).length) {
        if (amount) {
            return "".concat((currency === null || currency === void 0 ? void 0 : currency.icon) || getCurrencyIcon(code)).concat(calculateConversion(amount, rate), " ").concat(showCode ? code : "").trim();
        }
        return "".concat((currency === null || currency === void 0 ? void 0 : currency.icon) || getCurrencyIcon(code), "0 ").concat(code).trim();
    }
    return "S$".concat(formatNumber(amount, 0), " ").concat(code).trim();
};
var socialPrefixes = {
    linkedin: "https://www.linkedin.com/in/",
    twitter: "https://twitter.com/",
    facebook: "https://www.facebook.com/",
    instagram: "https://www.instagram.com/"
};
var addHttpPrefix = function(value, prefix) {
    // Need to add prefix if we don't have http:// prefix already AND we don't have part of it
    if (value && !/^(https?):\/\//i.test(value) && "http://".concat(prefix).indexOf(value) !== 0 && "https://".concat(prefix).indexOf(value) !== 0) {
        return "".concat(prefix).concat(value);
    }
    return value || "";
};
var setPageTitle = function(title) {
    document.title = title;
};
var openUrl = function(rawUrl) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _target = ref.target, target = _target === void 0 ? "_blank" : _target, forceHttps = ref.forceHttps, verifyUrl = ref.verifyUrl;
    var url = forceHttps === false ? rawUrl : rawUrl.replace(new RegExp("http://", "g"), "https://");
    return new Promise(function(resolve, reject) {
        if (verifyUrl) {
            // GET request is sent to check in advance if url is working
            axios.get(url).then(function() {
                // const a = document.createElement('a');
                // a.setAttribute('href', url);
                // a.setAttribute('target', target);
                // document.body.appendChild(a);
                // a.click();
                // a.remove();
                window.open(url, target);
                resolve();
            }).catch(function(err) {
                var ref;
                if (((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.status) || 0) < 400) {
                    // Ignore this error and resolve anyway.
                    window.open(url, target);
                    resolve();
                } else {
                    // Reject in case of 400 and above.
                    reject(err);
                }
            });
            return;
        }
        window.open(url, target);
        resolve();
    });
};
var formatBytes = function(size) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (!size) return "0 Bytes";
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var units = [
        "Bytes",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    var i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat((size / Math.pow(k, i)).toFixed(dm)) + " " + units[i];
};
var convertNumberToText = function(v) {
    var special = [
        "zeroth",
        "first",
        "second",
        "third",
        "fourth",
        "fifth",
        "sixth",
        "seventh",
        "eighth",
        "ninth",
        "tenth",
        "eleventh",
        "twelfth",
        "thirteenth",
        "fourteenth",
        "fifteenth",
        "sixteenth",
        "seventeenth",
        "eighteenth",
        "nineteenth", 
    ];
    var deca = [
        "twent",
        "thirt",
        "fort",
        "fift",
        "sixt",
        "sevent",
        "eight",
        "ninet"
    ];
    if (v < 20) return special[v];
    if (v % 10 === 0) return deca[Math.floor(v / 10) - 2] + "ieth";
    return deca[Math.floor(v / 10) - 2] + "y-" + special[v % 10];
};
var convertToSeconds = function(durationTimestamp) {
    var stringVal = String(durationTimestamp) || "";
    var stringArr = stringVal.split(":");
    var hour = parseInt(stringArr[0]) || 0;
    var min = parseInt(stringArr[1]) || 0;
    var sec = parseInt(stringArr[2]) || 0;
    return hour * 60 * 60 + min * 60 + sec;
};
var convertToHours = function(totalSeconds) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    return (totalSeconds / 3600).toFixed(decimals);
};
var generateAddress = function(address) {
    var addressString = "";
    if (address.address) {
        addressString += "".concat(address.address, ", ");
    }
    if (address.city) {
        addressString += "".concat(address.city, ", ");
    }
    if (address.region) {
        addressString += "".concat(address.region, ", ");
    }
    if (address.postalCode) {
        addressString += "".concat(address.postalCode, ", ");
    }
    if (address.country) {
        addressString += "".concat(address.country, ", ");
    }
    return addressString.slice(0, -2);
};
var AVG_WORD_PER_MIN = 200;
var extractTextOnly = function() {
    var htmlString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return htmlString.replace(/<\/?[^>]+(>|$)/g, "");
};
var getWordCount = function() {
    var values = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    return ((ref = values === null || values === void 0 ? void 0 : values.split(" ")) === null || ref === void 0 ? void 0 : ref.length) || 0;
};
var getWordCountFromHtml = function() {
    var htmlString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return getWordCount(extractTextOnly(htmlString));
};
var estimateReadTime = function(htmlString) {
    var words = getWordCountFromHtml(htmlString);
    return Math.ceil(words / AVG_WORD_PER_MIN);
};
var setValue = function(entry, value) {
    if (entry === undefined) {
        // eslint-disable-next-line
        console.warn({
            err: new Error("entry is undefined on setValue")
        });
        return "";
    }
    // eslint-disable-next-line
    entry = entry.replace(/(\{(\w+)\})/g, function(match, grp, key) {
        var ret = value[key];
        if (ret !== null && ret !== undefined) {
            return ret;
        }
        return match;
    });
    return entry;
};
var isOfTypeUuId = function(value) {
    var accessKeyRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
    return accessKeyRegex.test(value);
};
var dateSort = function(a, b) {
    var today = new Date().valueOf();
    var bEnd = b.endYear ? new Date(b.endYear, b.endMonth).valueOf() : today;
    var aEnd = a.endYear ? new Date(a.endYear, a.endMonth).valueOf() : today;
    if (bEnd === aEnd) {
        // Default to which was longer
        var bStart = b.startYear ? new Date(b.startYear, b.startMonth).valueOf() : today;
        var aStart = a.startYear ? new Date(a.startYear, a.startMonth).valueOf() : today;
        return bStart < aStart ? 1 : -1;
    }
    return bEnd < aEnd ? -1 : 1;
};
var simplifyErrors = function(errs) {
    if (!errs) return {};
    return Object.keys(errs || {}).reduce(function(p, c) {
        var err = errs[c][0];
        if (err) {
            p[c] = errs[c][0];
        }
        return p;
    }, {});
};
var checkImageUrl = function(imageUrl) {
    return (imageUrl || "").match(/\.(jpeg|JPEG|JPG|GIF|PNG|TIFF|JFIF|svg|SVG|WEBP|webp|jpg|gif|png|tiff|jfif)$/) != null;
};
var getPortfolioThumbnail = function(portfolioItem) {
    var ref, ref1;
    return (portfolioItem === null || portfolioItem === void 0 ? void 0 : portfolioItem.image) || (portfolioItem === null || portfolioItem === void 0 ? void 0 : portfolioItem.pageScreenshot) || ((ref = portfolioItem.caseItems) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image) || (portfolioItem === null || portfolioItem === void 0 ? void 0 : portfolioItem.attachment);
};
var isPortfolioThumbnailPageScreenshot = function(portfolioItem) {
    return !!(portfolioItem === null || portfolioItem === void 0 ? void 0 : portfolioItem.pageScreenshot) && !(portfolioItem === null || portfolioItem === void 0 ? void 0 : portfolioItem.image);
};
var snakeToCamel = function(str) {
    return str.toLowerCase().replace(/[-_][a-z]/g, function(group) {
        return group.slice(-1).toUpperCase();
    });
};
var formatWithComma = function(items) {
    if (items.length === 1) return items === null || items === void 0 ? void 0 : items[0];
    if (items.length > 1) {
        return items.slice(0, items.length - 1).join(", ") + " and " + items[items.length - 1];
    }
    return "";
};
var removeBaseUrl = function(url) {
    var urlPattern = /^https?:\/\/[-_a-z\:0-9.]+/;
    return url.replace(urlPattern, "");
};


/***/ }),

/***/ 5602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PolyLogo; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(1373);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(42);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(3615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../@hiredigital/ui/src/Logo/Logo.module.scss
var Logo_module = __webpack_require__(110);
var Logo_module_default = /*#__PURE__*/__webpack_require__.n(Logo_module);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Logo/svg/poly.inline.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgPolyinline = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 342,
  height: 167,
  viewBox: "0 0 342 167",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M23.4 133.988V82.1407H48C82.6 82.1407 104.2 66.9942 104.2 40.9733C104.2 15.1465 82.6 0 48 0H23.4L0.800003 18.0593V133.988H23.4ZM50.2 18.0593C69.6 18.0593 80.6 26.2151 80.6 40.9733C80.6 55.7314 69.6 64.0814 50.2 64.0814H23.4V18.0593H50.2ZM202.26 85.4419C202.26 59.2268 183.661 34.9535 153.261 34.9535C122.861 34.9535 104.261 59.2268 104.261 85.4419C104.261 111.657 122.861 135.93 153.261 135.93C183.661 135.93 202.26 111.657 202.26 85.4419ZM127.261 85.4419C127.261 64.664 136.661 50.6826 153.261 50.6826C170.061 50.6826 179.461 64.664 179.461 85.4419C179.461 106.026 170.061 120.201 153.261 120.201C136.661 120.201 127.261 106.026 127.261 85.4419ZM213.532 133.988H235.332V0L213.532 18.0593V133.988ZM296.366 167L341.766 36.8954H319.966L292.166 117.094L263.566 36.8954H241.566L272.166 122.726H290.166L274.766 167H296.366Z",
  fill: "currentColor"
})));

/* harmony default export */ var poly_inline = (SvgPolyinline);
;// CONCATENATED MODULE: ../@hiredigital/ui/src/Logo/PolyLogo.jsx







var Logo = function(_param) {
    var className = _param.className, type = _param.type, _site = _param.site, site = _site === void 0 ? "1" : _site, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "type",
        "site"
    ]);
    var logoSize = (Logo_module_default()).polyLogo;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(poly_inline, (0,_object_spread/* default */.Z)({
        className: classnames_default()(logoSize, className, type)
    }, props));
};
Logo.propTypes = {
    className: (prop_types_default()).string,
    type: (prop_types_default()).string
};
Logo.Type = {
    WHITE: (Logo_module_default()).white,
    BLACK: (Logo_module_default()).black,
    BLUE: (Logo_module_default()).blue,
    DARKBLUE: (Logo_module_default()).darkblue,
    DARKGRAY: (Logo_module_default()).darkgray
};
/* harmony default export */ var PolyLogo = (Logo);


/***/ }),

/***/ 966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var _Text_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5119);
/* harmony import */ var _Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Text_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







var Text = function(_param) {
    var tmp = _param.element, Elem = tmp === void 0 ? "p" : tmp, _size = _param.size, size = _size === void 0 ? (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().body) : _size, _color = _param.color, color = _color === void 0 ? (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().black) : _color, _type = _param.type, type = _type === void 0 ? (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().standard) : _type, className = _param.className, children = _param.children, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "element",
        "size",
        "color",
        "type",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Elem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().base), size, type, color, className)
    }, restProps), {
        children: children
    }));
};
/* 
size={Text.Size.HEADLINE}
color={Text.Color.WHITE}
*/ Text.Styles = (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default());
Text.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string),
    element: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)
};
Text.Type = {
    PRIMARY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().primary),
    SECONDARY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().secondary),
    NORMAL: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().standard),
    WHITE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().white),
    PARAGRAPH: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().paragraph),
    CENTER: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().center)
};
Text.Color = {
    BLACK: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().black),
    BLUE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blue),
    DARK_BLUE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().darkblue),
    BLOGBLUE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().blogBlue),
    WHITE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().white),
    GREY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().grey)
};
Text.Size = {
    HEADLINE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().headline),
    SUBHEADLINE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().subheadline),
    SUBHEADLINE_LARGE: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().subheadlineLarge),
    HEADING_TWO: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().headingTwo),
    BODY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().body),
    DISPLAY: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().display),
    H2: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().h2),
    H3: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().h3),
    H4: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().h4),
    H5: (_Text_module_scss__WEBPACK_IMPORTED_MODULE_2___default().h5)
};
/* harmony default export */ __webpack_exports__["Z"] = (Text);


/***/ }),

/***/ 110:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"Logo_white__2FS58","black":"Logo_black__xtvn6","blue":"Logo_blue__YOWB7","darkblue":"Logo_darkblue__A6hw6","darkgray":"Logo_darkgray__LkEBt","logo":"Logo_logo__lurSD","hdLogo":"Logo_hdLogo__WfXcv","hdMarketingLogo":"Logo_hdMarketingLogo__Uhg70","polyLogo":"Logo_polyLogo__vk3Q8"};

/***/ }),

/***/ 5119:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"display":"Text_display__51_no","headline":"Text_headline__ABAjm","subheadlineLarge":"Text_subheadlineLarge__CvyEY","subheadline":"Text_subheadline___mKuy","headingTwo":"Text_headingTwo__lCj6d","body":"Text_body__ttb3d","white":"Text_white__rlV81","grey":"Text_grey__674CG","base":"Text_base__0ik6d","paragraph":"Text_paragraph___go_l","center":"Text_center__56hVb","black":"Text_black__2lqNZ","blue":"Text_blue__06Ccf","blogBlue":"Text_blogBlue__0OTBW","darkblue":"Text_darkblue__sp4Ux","primary":"Text_primary__NgXiy","secondary":"Text_secondary__Hy_eZ","h2":"Text_h2__DliZ8","h3":"Text_h3__ETOR6","h4":"Text_h4__kevji"};

/***/ }),

/***/ 8593:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Gu1Of","secondary":"Button_secondary__g_QV3","arrow":"Button_arrow__M8EbW"};

/***/ }),

/***/ 5811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ruler":"Section_ruler__krkkN","anchor":"Section_anchor__X8Nz7","addMargin":"Section_addMargin__JdbFT","section":"Section_section___TusU","medium":"Section_medium__bdeco","large":"Section_large__7gWX1","innerContainerSection":"Section_innerContainerSection__bHwWP","container":"Section_container__TDOy0","splitContainer":"Section_splitContainer__0Ms_G","containerLightblue":"Section_containerLightblue__4p7ai","containerImageBlue":"Section_containerImageBlue__nYjFX","containerDarkblue":"Section_containerDarkblue__cuqXq","containerEnterpriseSplit":"Section_containerEnterpriseSplit__eC4gA","gridContainer":"Section_gridContainer__MoIvi","containerProfessionalSplit":"Section_containerProfessionalSplit__Ig_xj","containerEnterpriseFull":"Section_containerEnterpriseFull__x9BGw","containerPlainWhite":"Section_containerPlainWhite__MeaOU","leadgen":"Section_leadgen__uWGW5","image":"Section_image__O_Lv8","split":"Section_split___PqQa","splitContent":"Section_splitContent__4fB8y"};

/***/ })

}]);